import { createContext, useContext } from 'react';

/**
 * ADR-048 (Req 6.1): o achado que cita uma evidência complementar leva a ela. A ficha da visita fornece as evidências
 * que tem e como abrir uma no visualizador; fora da ficha (ou numa API anterior), não há contexto e o link não aparece.
 */
export interface VerEvidencia {
  /** Os `id` das evidências da ficha — o achado que cita outra (fora da lista) fica sem link. */
  readonly ids: ReadonlySet<string>;
  readonly abrir: (evidenciaId: string) => void;
}

export const VerEvidenciaContext = createContext<VerEvidencia | null>(null);

export function useVerEvidencia(): VerEvidencia | null {
  return useContext(VerEvidenciaContext);
}
